import { useDateFormatter } from '@/hooks/useDateFormatter';
import { useDividendTranslation } from '../../../../hooks/useDividendTranslations';
import StabilityAndGrowthOfPaymentsContainer from '../../containers/StabilityAndGrowthOfPaymentsContainer';
import type { useDividendsData } from '../../hooks/useDividendsData';
import type { ComponentPropsWithoutRef } from 'react';
import { useCallback } from 'react';
import type StabilityAndGrowthOfPayments from '../StabilityAndGrowthOfPayments';
interface Props {
  data: ReturnType<typeof useDividendsData>['data'];
}
export function TranslationWrapper({ data }: Props) {
  const t = useDividendTranslation();
  const { format } = useDateFormatter();
  const formatDate = useCallback<
    NonNullable<
      ComponentPropsWithoutRef<
        typeof StabilityAndGrowthOfPayments
      >['dateFormatter']
    >
  >((date, formatStr) => format(date, formatStr), [format]);

  return (
    <StabilityAndGrowthOfPaymentsContainer
      divPaymentDetailData={data}
      dateFormatter={formatDate}
      labels={{
        series01: t('stabilityAndGrowth.chart.series1'),
        series02: t('stabilityAndGrowth.chart.series2'),
        series03: t('stabilityAndGrowth.chart.series3'),
        series04: t('stabilityAndGrowth.chart.series4'),
        past: t('Past'),
        future: t('Analysts Forecasts'),
        notApplicable: t('n/a'),
        perYear: t('/year'),
      }}
    />
  );
}
